import { render, staticRenderFns } from "./AsignacionEsquemas.vue?vue&type=template&id=6f3fd5b7&scoped=true&"
import script from "./AsignacionEsquemas.vue?vue&type=script&lang=ts&"
export * from "./AsignacionEsquemas.vue?vue&type=script&lang=ts&"
import style0 from "./AsignacionEsquemas.vue?vue&type=style&index=0&id=6f3fd5b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3fd5b7",
  null
  
)

export default component.exports